import { fetchDataFailureGOS, fetchDataSuccessGOS } from "./actions";
import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';
import { FetchRequestAction } from "../../types/strapiGOS";
import { extractStrapiData, getDataGOS } from "../../api/api";

export function* fetchDataSagaGOS(action: FetchRequestAction) {
  const { modelName, params, append } = action.payload;
  try {
    const response: AxiosResponse<any> = yield call(getDataGOS, modelName, params);
    const extractedData = extractStrapiData(response);
    const paginationInfo = response.data?.meta?.pagination;
    yield put(fetchDataSuccessGOS(modelName, extractedData, paginationInfo, append));
  } catch (error) {
    const errorMessage = (error as any)?.message || '';
    yield put(fetchDataFailureGOS(modelName, errorMessage));
  }
}